export default __webpack_public_path__ + "static/media/chiles.402674ab.jpg";